require('./baseState.js');
// TODO this should be a substate of hover

Pegasus.ViewingOperationsState = Pegasus.BaseState.extend({
  moveUp: function(){
    this.hideOperations();
    Pegasus.lookupController('rowOperations').send('moveRowUp');
  },

  moveDown: function(){
    this.hideOperations();
    Pegasus.lookupController('rowOperations').send('moveRowDown');
  },

  edit: function(manager){
    var context = Pegasus.lookupController('blockOperations').get('content'),
      state = 'editing.'.concat(
        context.get('payload.type').camelize()
      );

    this.hideOperations();
    manager.transitionTo( state, context );
  },

  upload: function(manager){
    var context = Pegasus.lookupController('blockOperations').get('content'),
      state = 'editing.'.concat(
        context.get('payload.type').camelize()
      );

    this.hideOperations();
    manager.transitionTo( state, context );
    manager.send('editImage', context);
    Pegasus.lookupController('toolbar').replaceImage();
  },

  copy: function(manager){
    var context = Pegasus.lookupController('blockOperations').get('content'),
      parent = context.get('parentView'),
      copy = context.copy();

    this.hideOperations();
    parent.insertAt( parent.indexOf( context ) + 1, copy );
  },

  deleteBlock: function(manager){
    var block = Pegasus.lookupController('blockOperations').get('content'),
      backup = block.get('row').mutateForOut(null, true).editor_cookie;

    this.hideOperations();

    block.get('parentView').removeChild(block);
    block.destroy();

    var command = Pegasus.DeleteBlockCommand.create({
      klass: block.get('row').constructor,
      backup: backup,
      sourceElement: block.get('row').mutateForOut(null, true).editor_cookie,
      parent: Pegasus.blockRegionInstance,
      childPosition: block.get('row.parentView').indexOf( block.get('row') ),
      callback: function(){
        Pegasus.stateMachine.transitionTo('idling');
      }
    });

    command.execute();
  },

  hideOperations: function(){
    var blockOps = Pegasus.lookupController('blockOperations');
    blockOps.set('content', null);
  },

  didFinishViewing: function(manager){
    manager.transitionTo('idling');
  },

  gotoIdle: function(manager){
    manager.transitionTo('idling');
  },

  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  },

  hover: function(manager, context){
    manager.transitionTo('idling');
    manager.send('hover', context);
  },

  changePalette: function(manager, view){
    manager.transitionTo('editing.palette', view);
  }
});
